import actionTypes from '../actionTypes'

const updatePaymentsPlan = plan => {
  return {
    type: actionTypes.SET_PAYMENTS_PLAN,
    payload: plan,
  }
}

const updatePlanLimit = planLimit => {
  return {
    type: actionTypes.SET_PLAN_LIMIT,
    payload: planLimit,
  }
}

const updatePlanNoticeVisible = visible => {
  return {
    type: actionTypes.SET_PLAN_NOTICE_VISIBLE,
    payload: visible,
  }
}

export default {
  updatePaymentsPlan,
  updatePlanLimit,
  updatePlanNoticeVisible
}